import React from 'react';
import ReactDOM from 'react-dom';
import Product from './Product';
import Spinner from 'ui/Spinner';
import Wrapper from 'ui/Wrapper';
import * as RaceNavigation from 'ui/RaceNavigation';
import { byPlatform, forMobile } from 'utils/platforms';
import { ScrollBar } from 'ui/RaceNavigation';

class Products extends React.Component {
    activeButtonPosition = 0;

    componentDidUpdate() {
        const scrollBarElement = ReactDOM.findDOMNode(
            this.refs.scrollContainer
        );
        scrollBarElement.scrollLeft = this.activeButtonPosition;
    }

    onSelectHandler = (event, product) => {
        const correction = 60;
        this.activeButtonPosition = event.clientX - correction;

        this.props.onSelect(product);
    };

    render() {
        return this.props.data ? (
            <RaceNavigation.ScrollBar
                ref="scrollContainer"
                data-test-id="products-section"
                style={byPlatform({}, { marginTop: '-7px' })}
            >
                {this.props.data.map((item, index) => (
                    <Product
                        onSelect={this.onSelectHandler}
                        active={
                            this.props.selectedProduct &&
                            this.props.selectedProduct.id === item.id
                        }
                        disabled={item.disabled}
                        key={index}
                        product={item}
                        last={index + 1 === this.props.data.length}
                    />
                ))}
                {/* fixes Mob. Padding after the last button DER-2629 (padding-right doesn't work for mobile) */}
                {forMobile(<RaceNavigation.ScrollbarRightIndent />)}
            </RaceNavigation.ScrollBar>
        ) : (
            <Wrapper>
                <Spinner />
            </Wrapper>
        );
    }
}

export default Products;
